<h2 mat-dialog-title>Please Confirm</h2>
<div mat-dialog-content>
  <div class="mat-body-2">{{data.message}}</div>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="accent" (click)="dialogRef.close(false)">Cancel</button>
  <button mat-raised-button color="warn" (click)="dialogRef.close(true)">Confirm</button>
</div>
